export default {
  GET_INQUIRIES: (state) => state.inquiries,
  GET_INQUIRY: (state) => state.inquiry,
  GET_INQUIRY_ITEMS : (state) => state.inquiryItems,
  GET_BASE_INQUIRIES: (state) => state.baseInquiries, 
  GET_BASE_INQUIRY_INQUIRIES : (state) => state.baseInquiryInquiries,
};
